import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { useNavigate } from "react-router-dom";

import EndPointService from "../services/endpoint";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage("user", null);
    const [token, setToken] = useLocalStorage("token", null);
    const [roles, setRoles] = useLocalStorage("roles", []);
    const navigate = useNavigate();

    const login = async (username, password) => {
        return Promise.resolve()
            .then(() => EndPointService.login(username, password))
            .then(({username, token, roles}) => {
                setUser(username)
                setToken(token)
                setRoles(Array.isArray(roles) ? roles : [])
            })
    };

    const logout = () => {
        setUser(null);
        setToken(null);
        setRoles([]);
        navigate("/", { replace: true });
    };

    const check = () => {
        return Promise.resolve()
            .then(() => EndPointService.check())
            .catch(() => logout())
    }

    const value = useMemo(() => ({
        user,
        token,
        roles,
        isAdmin: Array.isArray(roles) && roles.includes('admin'),
        login,
        logout,
        check,
        // eslint-disable-next-line
    }), [user, roles]);
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};